<template>
  <!-- eslint-disable -->
  <div class="terms">
    <Nav :transparent="transparent" />
    <section class="app-info container section">
      <h1 class="title is-1 is-size-3-touch">
        Termos e condições gerais de uso
      </h1>
      <div class="content">
        <h3 class="title is-4">1 - Objeto do presente termo</h3>
        <p>
          O presente termo tem por objetivo
          estabelecer as condições gerais de uso da plataforma virtual de
          agendamentos <i>useagendei.com</i>, de propriedade da empresa <strong>FirstBits - ME</strong>,
          vinculando o usuário a partir de seu aceite; por meio do qual
          concorda e se compromete a respeitá-las.
        </p>
        <p>
          O presente termo poderá ser
          alterado pela <strong>FirstBits</strong> a qualquer momento e sem necessidade de
          aviso prévio, estando as versões disponíveis para consulta por meio
          do <i>link</i>: <a href="https://useagendei.com/termos">https://useagendei.com/termos</a>.
        </p>
        <p>
          As condições abaixo descritas regularão a relação entre o usuário
          e <strong>FirstBits</strong>, na utilização da plataforma <i>useagendei.com</i>, de modo que em
          havendo discordância de seus termos por parte do usuário,
          recomenda-se não aceita-las.
        </p>
        <p>
          As aceitações das condições de uso
          abaixo outorgam ao usuário licença de utilização da plataforma 
          <i>useagendei.com</i>, reservando-se à Firstbits quaisquer direitos sobre a
          sobre a plataforma. Quaisquer práticas conflitantes com as condições
          abaixo poderão motivar a cassação da licença e cancelamento do perfil do
          usuário na plataforma agendeio.io, independentemente de qualquer aviso
          prévio.
        </p>
        <h3 class="title is-4">
          2 – Da competência para contratar
        </h3>
        <p>
          Ao aceitar as condições abaixo descritas, o usuário tacitamente declara possuir capacidade para
          contratar, relativa ou integralmente, recomendando-se o auxílio de
          pessoa maior de 18 (dezoito) anos na compreensão do presente termo para
          usuários menores.
        </p>
        <h3 class="title is-4">
          3 – Das limitações de responsabilidade
        </h3>
        <p>
          O usuário declara possuir conhecimento de que a plataforma <i>useagendei.com</i> não possui
          qualquer relação societária com quaisquer dos <strong>Salões</strong> licenciados, não se
          responsabilizando por quaisquer danos experimentados ao gozar dos
          serviços destes, seja de ordem material, moral e/ou estética.
        </p>
        <p>
          Ao aceitar o presente, atesta o usuário ter conhecimento de que as atividades da
          plataforma <i>useagendei.com</i> se referem exclusivamente à promoção da
          aproximação de seus usuários com os <strong>SALÕES</strong> licenciados, agendamento de
          serviços, bem como de fornecimento de mecanismos de gestão e pagamento a
          estes, não possuindo qualquer <i>expertise</i> para avaliar a capacidade
          técnica dos <strong>SALÕES</strong>, e/ou qualquer ingerência sobre suas práticas, preços
          e promoções.
        </p>
        <h3 class="title is-4">
          4 – Do cadastro, senha e responsabilidades do usuário quanto à sua atualização e guarda.
        </h3>
        <p>
          São informações indispensáveis ao cadastro os seguintes <strong>dados pessoais</strong> do usuário: <br />
          <ul>
            <li>Nome completo;</li>
            <li>CPF;</li>
            <li>Endereço eletrônico (e-mail);</li>
            <li>Sexo;</li>
            <li>Data de nascimento; e</li>
            <li>Número de telefone;</li>
          </ul>
        </p>
        <p>
          Além das informações acima, caso o usuário pretenda utilizar a plataforma <i>useagendei.com</i> para a realização de pagamentos de seus agendamentos junto aos <strong>SALÕES</strong>, por meio de cartão de crédito, também deverá fornecer os necessários <strong>dados de pagamento</strong> por meio da opção “Adicionar Cartão”, quais sejam:<br />
          <ul>
            <li>Número do cartão de crédito;</li>
            <li>Bandeira;</li>
            <li>Nome estampado no cartão;</li>
            <li>Data de validade; e</li>
            <li>Código de Segurança (constante do verso do cartão);</li>
          </ul>
        </p>
        <p>
          Todos os <strong>dados pessoais</strong> e/ou <strong>dados de pagamento</strong> cadastrados pelo usuário na plataforma <i>useagendei.com</i> são devidamente protegidos por nossa <strong>Política de Privacidade</strong> (https://useagendei.com/privacidade), sendo garantido ao usuário sua guarda nos termos nela dispostos.
        </p>
        <p>
          Após adicionar o <strong>ESTABELECIMENTO</strong> licenciado como salão, os dados pessoais do usuário constarão da base de dados do <strong>ESTABELECIMENTO</strong> licenciado, facilitando-se assim a comunicação entre ambos.
        </p>
        <p>
          A conclusão do cadastro se dará com a definição, por parte do usuário, de senha alfanumérica, de uso pessoal e intransferível, cabendo ao usuário sua guarda e sigilo, não podendo ser atribuída à Firstbits a responsabilidade por qualquer atividade realizada por terceiros na plataforma <i>useagendei.com</i> com a utilização de senha validada por usuário.
        </p>
        <p>
          O usuário se compromete a notificar a <strong>FirstBits</strong>, por meio do endereço eletrônico (e-mail) contato@<i>useagendei.com</i>, sobre qualquer acesso indevido a seu perfil. Notificações posteriores, contudo, não afastam a responsabilidade do usuário por eventuais perdas ou danos experimentados pela <strong>FirstBits</strong> com o acesso do terceiro.
        </p>
        <p>
          Não será permitida a pluralidade de usuários com o mesmo CPF e <i>e-mail</i>, de modo que apenas uma conta vinculada a esses dados será permitida navegar na plataforma.
        </p>
        <h3 class="title is-4">
          5 – Dos pagamentos realizados por meio da plataforma <i>useagendei.com</i>
        </h3>
        <p>
          Os usuários poderão optar por realizar o pagamento dos serviços agendados utilizando-se de cartão de crédito por meio da plataforma <i>useagendei.com</i>.
        </p>
        <p>
          O cartão a ser utilizado no pagamento dos serviços agendados deverá estar cadastrado nos <strong>dados de pagamento</strong> do usuário.
        </p>
        <p>
          A plataforma <i>useagendei.com</i> atuará como mera agente cobradora dos serviços, não possuindo qualquer ingerência sobre preços e promoções dos <strong>SALÕES</strong> licenciados.
        </p>
        <p>
          O pagamento realizado por meio da plataforma <i>useagendei.com</i> será considerado como feito pelo usuário diretamente ao <strong>ESTABELECIMENTO</strong> licenciado, e deverá incluir todos os impostos e taxas exigidos por lei, cuja apuração cabe unicamente ao <strong>ESTABELECIMENTO</strong> licenciado.
        </p>
        <p>
          O preço dos serviços passará a ser devido pelo usuário ao <strong>ESTABELECIMENTO</strong> licenciado após a prestação integral deles. O recibo de pagamento dos serviços adquiridos por meio da plataforma <i>useagendei.com</i> será enviado por meio de correio eletrônico (e-mail) ao endereço cadastrado nos <strong>dados pessoais</strong> do usuário.
        </p>
        <p>
          Eventuais pagamentos não concluídos por indisponibilidade de créditos junto à operadora do cartão do usuário implicarão na suspensão do perfil na plataforma até a regularização da situação junto à operadora do cartão.
        </p>
        <h3 class="title is-4">
          6 – Da disponibilidade dos serviços
        </h3>
        <p>
          A plataforma do <i>useagendei.com</i> poderá sofrer com intermitências de disponibilidade decorrentes de atualizações, interferências, vírus, indisponibilidade de rede e outros eventos que sejam controláveis ou incontroláveis pela <strong>FirstBits</strong>.
        </p>
        <p>
          O usuário da plataforma declara, portanto, ter ciência de que a plataforma poderá ficar momentaneamente indisponível e reconhece a ausência de responsabilidade da <strong>FirstBits</strong> por qualquer prejuízo decorrente de intermitência de disponibilidade.
        </p>
        <p>
          Qualquer alteração de agenda e/ou cancelamento operado por algum <strong>ESTABELECIMENTO</strong> licenciado no período de indisponibilidade é de única e exclusiva responsabilidade deste.
        </p>
        <p>
          O usuário se compromete a evitar qualquer ação que imponha à plataforma <i>useagendei.com</i> sobrecarga, ou que lhe torne vulnerável a quaisquer vírus.
        </p>
        <h3 class="title is-4">
          7 – Da propriedade intelectual
        </h3>
        <p>
          O usuário se compromete a respeitar os direitos de propriedade intelectual seja das marcas da plataforma <i>useagendei.com</i>, seja de eventual conteúdo publicado por outro usuário e/ou ESTABELECIMENTO licenciado na plataforma <i>useagendei.com</i>.
        </p>
        <p>
          Todo o conteúdo artístico da plataforma <i>useagendei.com</i>, incluindo suas marcas, layouts e imagens é de propriedade exclusiva da <strong>FirstBits - ME</strong>, sendo certo que a outorga de licença de utilização da plataforma aos usuários não se estende a este conteúdo.
        </p>
        <p>
          A infringência aos direitos de propriedade intelectual acima descritos ensejará a cassação da licença e revogação do perfil do usuário, sem prejuízo das penalizações impostas em legislação especial.
        </p>
        <h3 class="title is-4">
          8 – Do cancelamento do usuário
        </h3>
        <p>
          O usuário poderá, a qualquer momento, sem necessidade de qualquer aviso prévio, cancelar seu perfil de acesso à plataforma <i>useagendei.com</i>, por meio da aba <span style="color: red">“Minha Conta”</span>.
        </p>
        <p>
          O perfil do usuário também poderá ser cancelado por iniciativa da <strong>FirstBits</strong> em caso de infringência às condições de uso da plataforma <i>useagendei.com</i> aqui dispostas, em quaisquer ocasiões nelas previstas ou não, sem qualquer aviso prévio.
        </p>
        <p>
          Os <strong>dados pessoais</strong> de eventual perfil cancelado serão mantidos pela plataforma <i>useagendei.com</i>, nos termos da <strong>Política de Privacidade</strong>, sobretudo para evitar reingresso na plataforma de usuário cassado.
        </p>
        <p>
          O cancelamento voluntário do perfil não desonera o usuário de eventual pagamento pendente, que tenha sido efetivado por meio da plataforma <i>useagendei.com</i>.
        </p>
        <p>
          A não adoção de qualquer ação por parte da plataforma <i>useagendei.com</i> para remediar infrações às presentes condições gerais de uso não importarão em renúncia/perdão, podendo a necessária medida ser tomada a qualquer momento, sem qualquer aviso prévio.
        </p>
        <h3 class="title is-4">
          9 – Das disposições finais
        </h3>
        <p>
          O presente termo e as condições nele dispostas foram redigidos em plena observância à legislação brasileira, sobretudo no tocante às Leis 8.078/1990, 10.406/2002 e 12.965/2014, possuindo, assim, validade em todo o âmbito nacional.
        </p>
        <p>
          A <i>useagendei.com</i> não será responsabilizada por qualquer danos e prejuízos por si causados em virtude de caso fortuito ou força maior.
        </p>
        <p>
          Toda a comunicação entre o usuário e a <i>useagendei.com</i> se dará por meio de correios eletrônicos (e-mails) que serão endereçados ao endereço constante dos <strong>dados pessoais</strong> do usuário.
        </p>
        <p>
          Caso deseje maiores informações, contate-nos por meio do endereço eletrônico <a href="mailto:contato@useagendei.com">contato@useagendei.com</a>.
        </p>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: {
    Nav,
    Footer
  },
  props: {
    pageTitle: {
      type: String,
      required: false,
      default: 'Termos de Uso'
    }
  },
  data() {
    return {
      transparent: -1
    };
  }
};
</script>

<style lang="scss">
.terms {
  position: relative;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .app-info {
    margin-top: 2em;

    .content {
      text-align: justify;
      margin-top: 5em;

      p {
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 18px;
      }
    }
  }
}
</style>
